import { httpClient } from '../httpClientOfTemporaryLogin';
export class UserinfoRepository {
    async verifyAccessToken(params) {
        const { data } = await httpClient.post('userinfo/verify-access-token', JSON.stringify(params));
        return data;
    }
    async changeSettingPassword(params) {
        const { data } = await httpClient.post('userinfo/change-setting-password', JSON.stringify(params));
        return data;
    }
}
